import React, { FC } from 'react';
import { IBidIdentifier } from 'src/models/bids/Bids/types';
import styles from './index.module.scss';
import LinkToBid from './LinkToBid';

interface IProps {
  title: string;
  bids: IBidIdentifier[];
}

export const ConfirmContent: FC<IProps> = props => {
  const { title, bids } = props;

  return (
    <>
      <p className={styles.desc}>{title}</p>

      {bids.map(bid => (
        <LinkToBid bidId={bid.id} key={bid.id} />
      ))}
    </>
  );
};

export default ConfirmContent;
